import type { IconData } from '@stacksjs/iconify-core'

export const pinAltF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 10.465a5.002 5.002 0 0 1 1-9.9a5 5 0 0 1 1 9.9v9.1a1 1 0 0 1-2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default pinAltF
